import BaseService from './BaseService'

class AuthService extends BaseService {
  constructor() {
    super('')
  }

  async login(credentials) {
    await this.customRequest('get', '/sanctum/csrf-cookie', null)
    return await this.customRequest('post', '/login', credentials)
  }

  async logout() {
    await this.customRequest('post', '/auth/logout')
  }

  async resetPassword(token, email, password) {
    await this.customRequest('get', '/sanctum/csrf-cookie', null)
    return await this.customRequest('post', '/auth/reset-password', {
      token,
      email,
      password,
      password_confirmation: password
    })
  }

  async fetchUser() {
    return await this.customRequest('get', '/user')
  }
}

export const authService = new AuthService()
